import {
	AlertTwotone,
	ArrowDownOutlined,
	AuditOutlined,
	BankTwotone,
	CalculatorOutlined,
	CheckCircleOutlined,
	CheckSquareTwotone,
	CloudDownloadOutlined,
	CopyOutlined,
	CreditCardTwotone,
	DeleteTwotone,
	EditTwotone,
	ExperimentTwotone,
	FileAddTwotone,
	FileExcelOutlined,
	FilePdfTwotone,
	FileSearchOutlined,
	FileTextTwotone,
	FolderOpenTwotone,
	FolderTwotone,
	GroupOutlined,
	HistoryOutlined,
	HomeTwotone,
	InboxOutlined,
	InfoCircleTwotone,
	LockTwotone,
	MessageTwotone,
	MinusCircleOutlined,
	MoreOutlined,
	NotificationTwotone,
	PlusCircleOutlined,
	ProjectTwotone,
	ReloadOutlined,
	SearchOutlined,
	SendOutlined,
	SettingTwotone,
	ShopTwotone,
	PhoneOutlined,
	SwapOutlined,
	UserAddOutlined,
	WhatsAppOutlined,
} from '@vicons/antd';

import {
	ChatBubbleOutlineTwotone,
	CheckCircleOutlineTwotone,
	DarkModeOutlined,
	InsightsRound,
	LabelTwotone,
	LightModeOutlined,
	LiveHelpTwotone,
	LockResetTwotone,
	LogOutTwotone,
	PixRound,
	PlayArrowFilled,
	SettingsBackupRestoreSharp,
	ShoppingCartRound,
	StopOutlined,
	SyncProblemTwotone,
	WarningAmberTwotone,
	AddCircleOutlineFilled,
	TodayOutlined,
	ApartmentRound,
	HouseRound,
	FireExtinguisherOutlined,
	ExitToAppOutlined,
	AttachMoneyOutlined,
	ArrowRightAltFilled,
	KeyFilled,
	SchoolTwotone,
	AccountBalanceWalletOutlined,
} from '@vicons/material';

export class Icons {
	static Copy = CopyOutlined;
	static Today = TodayOutlined;
	static Sheets = FileExcelOutlined;
	static ChevronDown = ArrowDownOutlined;
	static Proposal = FileAddTwotone;
	static NewProposal = FileAddTwotone;
	static Contract = FileTextTwotone;
	static GroupOutlined = GroupOutlined;
	static Simulator = ExperimentTwotone;
	static MortgageProduct = BankTwotone;
	static Logout = LogOutTwotone;
	static User = UserAddOutlined;
	static FolderOutlined = FolderTwotone;
	static FolderOpen = FolderOpenTwotone;
	static Done = CheckCircleOutlineTwotone;
	static Download = CloudDownloadOutlined;
	static Open = FileSearchOutlined;
	static PreAudit = FileSearchOutlined;
	static Home = HomeTwotone;
	static Commercial = ShopTwotone;
	static CreditCard = CreditCardTwotone;
	static Invoice = FileTextTwotone;
	static Pix = PixRound;
	static Invoiced = FileTextTwotone;
	static DarkMode = DarkModeOutlined;
	static LightMode = LightModeOutlined;
	static Label = LabelTwotone;
	static Inbox = InboxOutlined;
	static Settings = SettingTwotone;
	static Notification = NotificationTwotone;
	static Security = LockTwotone;
	static Info = InfoCircleTwotone;
	static MoreVert = MoreOutlined;
	static History = HistoryOutlined;
	static Delete = DeleteTwotone;
	/** Pedido de cancelamento que passa por análise: é um envio, e o ícone diz isso. */
	static CancelRequest = SendOutlined;
	/** Cancelamento imediato, sem análise. */
	static CancelNow = StopOutlined;
	static ResetPassword = LockResetTwotone;
	static Onboarding = SchoolTwotone;
	static Send = SendOutlined;
	static StatusToArrow = SwapOutlined;
	static Alert = AlertTwotone;
	static Checkmark = CheckSquareTwotone;
	static MessageEmpty = MessageTwotone;
	static Refresh = ReloadOutlined;
	static Edit = EditTwotone;
	static Search = SearchOutlined;
	static Product = ProjectTwotone;
	static Whatsapp = WhatsAppOutlined;
	static Phone = PhoneOutlined;
	static Update = ReloadOutlined;
	static Disregard = MinusCircleOutlined;
	static Reconsider = PlusCircleOutlined;
	static Financial = ProjectTwotone;
	static ReportPDF = FilePdfTwotone;
	static Legal = AuditOutlined;
	static Signed = AuditOutlined;
	static TimelineCompleted = CheckCircleOutlined;
	static TimelinePending = InfoCircleTwotone;
	static ChatMessage = ChatBubbleOutlineTwotone;
	static FAQ = LiveHelpTwotone;

	static Insights = InsightsRound;
	static Warning = WarningAmberTwotone;
	static AudioPlay = PlayArrowFilled;
	static AudioStop = StopOutlined;
	static Deactivate = StopOutlined;
	static Reactivate = PlayArrowFilled;

	// Novos ícones para UX melhorada
	static MonetizationOn = CreditCardTwotone;
	static Calculate = CalculatorOutlined;
	static Payment = CreditCardTwotone;
	static People = GroupOutlined;
	static Receipt = FileTextTwotone;
	static Description = FileTextTwotone;

	static CheckoutCart = ShoppingCartRound;
	static SyncProblem = SyncProblemTwotone;
	static Refund = SettingsBackupRestoreSharp;

	static AddCircle = AddCircleOutlineFilled;

	static Apartment = ApartmentRound;
	static House = HouseRound;
	static FireExtinguisher = FireExtinguisherOutlined;
	static ExitToApp = ExitToAppOutlined;
	static Money = AttachMoneyOutlined;
	static Wallet = AccountBalanceWalletOutlined;
	static ArrowRight = ArrowRightAltFilled;

	static KeyIcon = KeyFilled;
}

export default Icons;
